import { eraseCookie, getCookie, setCookie } from "@/utils"; // duplicate to remove
const COOKIE_NAME = "contact_autofill";
export const usePrefillDataCookie = () => {
    const setPrefillDataCookie = (data) => {
        const dataToSave = encodeURIComponent(JSON.stringify(data));
        setCookie(COOKIE_NAME, dataToSave, 365);
    };
    const erasePrefillDataCookie = () => {
        eraseCookie(COOKIE_NAME);
    };
    // @ts-ignore
    const getPrefillDataCookie = () => {
        const cookie = getCookie(COOKIE_NAME);
        if (cookie) {
            const cookieData = JSON.parse(decodeURIComponent(cookie));
            delete cookieData.message;
            return cookieData;
        }
    };
    return {
        setPrefillDataCookie,
        getPrefillDataCookie,
        erasePrefillDataCookie,
    };
};
